/* unplugin-vue-components disabled */import { render } from "./HomeView2.vue?vue&type=template&id=ced1e864&scoped=true"
import script from "./HomeView2.vue?vue&type=script&lang=js"
export * from "./HomeView2.vue?vue&type=script&lang=js"

import "./HomeView2.vue?vue&type=style&index=0&id=ced1e864&lang=scss&scoped=true"

import exportComponent from "F:\\hjd\\dev\\yf-dsj\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced1e864"]])

export default __exports__